import Vue from "vue";
import VueRouter from "vue-router";

import store from "@/store/store";

import appLayout from "@/components/layouts/app.layout.vue";
import contentLayout from "@/components/layouts/content-only.layout.vue";

import companiesView from "@/components/views/companies/list-companies.view.vue";
import swo from "@/components/views/swo/swo.view.vue";
import calendarView from "@/components/views/calendar/calendar.view.vue";
import sentEmails from "@/components/views/sent-emails/sent-emails.view.vue";
import listHolidays from "@/components/views/holidays/list-holidays.view.vue";
import listTags from "@/components/views/tags/list-tags.view.vue";
import listEmailDeliveries from "@/components/views/emails/list-email-deliveries.view.vue";
import listEmailTemplates from "@/components/views/emails/list-email-templates.view.vue";
import listEmailSignatures from "@/components/views/emails/list-email-signatures.view.vue";
import listEmailAccounts from "@/components/views/emails/list-email-accounts.view.vue";
import contractorObligations from "@/components/views/contractor-company/obligations/contractor-obligations.view.vue";
import contractorTypeView from "@/components/views/contractor-type/list-contractor-type.view.vue";
import contractorCompanyView from "@/components/views/contractor-company/list-contractor-company.view.vue";
import contractorEmployees from "@/components/views/contractor-company/employees/contractor-employees.view.vue";
import contractorEmployeesObligations from "@/components/views/contractor-company/employees/contractor-employees-obligations.view.vue";
import contractorProfile from "@/components/views/contractor-company/profile/contractor-profile.view.vue";
import contractorVehicles from "@/components/views/contractor-company/vehicles/contractor-vehicles.view.vue";
import contractorVehiclesObligations from "@/components/views/contractor-company/vehicles/contractor-vehicles-obligations.view.vue";
import contractorView from "@/components/views/contractor/list-contractor.view.vue";
import employeeTypeView from "@/components/views/employees-type/list-employees-type.view.vue";
import listAdditionalObligations from "@/components/views/obligations/additional/list-additional-obligations.view.vue";
import listHistoryView from "@/components/views/history/list-history-visits.view.vue";
import listUsersView from "@/components/views/users/list-users.view.vue";
import loginView from "@/components/views/login/login.view.vue";
import noSuitableContractorCompanyView from "@/components/views/contractor-company/nosuitable-contractor-company.view.vue";
import obligationView from "@/components/views/obligations/list-obligation.view.vue";
import searchContractor from "@/components/views/search/contractor/search-contractor.view.vue";
import sendContactView from "@/components/views/contact/send-contact.view.vue";
import suitableContractorCompanyView from "@/components/views/contractor-company/suitable-contractor-company.view.vue";
import activeHistoryView from "@/components/views/history/active-history-visits.view.vue";
import vehicleTypeView from "@/components/views/vehicles-type/list-vehicle-type.view.vue";
import viewVisit from "@/components/views/search/view-visits/view-visits.view.vue";
import constants from "@/utils/constants";

Vue.use(VueRouter);

const routes = [
  {
    path: "/auth",
    component: contentLayout,
    children: [
      {
        name: "login",
        path: "login",
        component: loginView
      }
    ]
  },

  {
    name: "home",
    path: "/",
    component: appLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: "additionalObligations",
        path: "obligations/additionals",
        component: listAdditionalObligations,
        meta: {
          requiresAuth: [
            store.state.constants.roles.SYS_ADMIN,
            store.state.constants.roles.SYS_SUPERVISOR,
            store.state.constants.roles.USER
          ]
        }
      },

      // contact
      {
        name: "sendContact",
        path: "contact/send",
        component: sendContactView,
        meta: {
          requiresAuth: [
            store.state.constants.roles.ADMIN,
            store.state.constants.roles.USER
          ]
        }
      },

      // companies
      {
        name: "companies",
        path: "companies",
        component: companiesView,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },

      // contractor company
      {
        name: "search-contractor",
        path: "search/contractor",
        component: searchContractor,
        meta: {
          requiresAuth: [store.state.constants.roles.SECURITY]
        }
      },

      {
        name: "contractorsCompany",
        path: "contractors-company/all",
        component: contractorCompanyView,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES.concat(
            store.state.constants.roles.ONLY_ADMINS
          ).concat(store.state.constants.roles.USER)
        }
      },
      {
        name: "suitableContractorCompany",
        path: "contractors-company/suitable",
        component: suitableContractorCompanyView,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES.concat(
            store.state.constants.roles.ONLY_ADMINS
          ).concat(store.state.constants.roles.USER)
        }
      },
      {
        name: "noSuitableContractorCompany",
        path: "contractors-company/no-suitable",
        component: noSuitableContractorCompanyView,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES.concat(
            store.state.constants.roles.ONLY_ADMINS
          ).concat(store.state.constants.roles.USER)
        }
      },
      {
        name: "contractorObligations",
        path: "contractors/:id/obligations",
        component: contractorObligations,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },
      {
        name: "contractorVehicles",
        path: "contractors/:id/vehicles",
        component: contractorVehicles,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },
      {
        name: "contractorVehiclesObligations",
        path: "contractors/:id/vehicles/:vid/obligations",
        component: contractorVehiclesObligations,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },
      {
        name: "contractorEmployeesObligations",
        path: "contractors/:id/employees/:eid/obligations",
        component: contractorEmployeesObligations,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },
      {
        name: "contractorEmployees",
        path: "contractors/:id/employees",
        component: contractorEmployees,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },
      {
        name: "contractorProfile",
        path: "contractors/:id/profile",
        component: contractorProfile,
        meta: {
          requiresAuth: true
        }
      },

      // contractor type
      {
        name: "contractorType",
        path: "contractor-type",
        component: contractorTypeView,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },

      // contractors
      {
        name: "contractors",
        path: "contractors",
        component: contractorView,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },

      // employee type
      {
        name: "employee-type",
        path: "employee-type",
        component: employeeTypeView,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },

      // obligations
      {
        name: "obligations",
        path: "obligations",
        component: obligationView,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },

      // users
      {
        name: "users",
        path: "users",
        component: listUsersView,
        meta: {
          requiresAuth: store.state.constants.roles.ONLY_ADMINS
        }
      },

      // vehicle type
      {
        name: "vehicle-type",
        path: "vehicle-type",
        component: vehicleTypeView,
        meta: {
          requiresAuth: store.state.constants.roles.ALL_SYS_ROLES
        }
      },

      // visits
      {
        name: "history",
        path: "history/all",
        component: listHistoryView,
        meta: {
          requiresAuth: [
            store.state.constants.roles.ADMIN,
            store.state.constants.roles.SYS_ADMIN,
            store.state.constants.roles.USER
          ]
        }
      },
      {
        name: "activeHistory",
        path: "history/active",
        component: activeHistoryView,
        meta: {
          requiresAuth: [
            store.state.constants.roles.ADMIN,
            store.state.constants.roles.SYS_ADMIN,
            store.state.constants.roles.USER
          ]
        }
      },
      {
        name: "viewVisits",
        path: "view/visits",
        component: viewVisit,
        meta: {
          requiresAuth: [store.state.constants.roles.SECURITY]
        }
      },

      // SCO
      {
        name: "swo",
        path: "swo",
        component: swo,
        meta: {
          requiresAuth: [store.state.constants.roles.SYS_ADMIN]
        }
      },

      // calendar
      {
        name: "calendar",
        path: "calendar",
        component: calendarView,
        meta: {
          requiresAuth: [
            store.state.constants.roles.SYS_ADMIN,
            store.state.constants.roles.ADMIN,
            store.state.constants.roles.USER
          ]
        }
      },

      // email log
      {
        name: "sentEmails",
        path: "sent-emails",
        component: sentEmails,
        meta: {
          requiresAuth: [store.state.constants.roles.SYS_ADMIN]
        }
      },

      // feriados
      {
        name: "holidays",
        path: "holidays",
        component: listHolidays,
        meta: {
          requiresAuth: [store.state.constants.roles.SYS_ADMIN]
        }
      },

      // etiquetas
      {
        name: "tags",
        path: "tags",
        component: listTags,
        meta: {
          requiresAuth: [store.state.constants.roles.SYS_ADMIN]
        }
      },

      // envios
      {
        name: "emailDeliveries",
        path: "email-deliveries",
        component: listEmailDeliveries,
        meta: {
          requiresAuth: [store.state.constants.roles.SYS_ADMIN]
        }
      },

      // plantillas de correo
      {
        name: "emailTemplates",
        path: "email-templates",
        component: listEmailTemplates,
        meta: {
          requiresAuth: [store.state.constants.roles.SYS_ADMIN]
        }
      },

      // firmas de correo
      {
        name: "emailSignatures",
        path: "email-signatures",
        component: listEmailSignatures,
        meta: {
          requiresAuth: [store.state.constants.roles.SYS_ADMIN]
        }
      },
      // cuentas remitentes
      {
        name: "emailAccounts",
        path: "email-accounts",
        component: listEmailAccounts,
        meta: {
          requiresAuth: [store.state.constants.roles.SYS_ADMIN]
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  routes: routes
});

router.beforeEach((to, from, next) => {
  const result = canNavigate(to);
  if (result.valid) {
    next();
  } else {
    if (result.routeTo) {
      next({ name: result.routeTo });
    } else {
      next(false);
    }
  }
});

const canNavigate = route => {
  if (!route.meta.requiresAuth) {
    return {
      valid: true
    };
  }

  if (route.meta.requiresAuth === true) {
    if (!store.state.auth.isAuth) {
      return {
        valid: false,
        routeTo: "login"
      };
    }
    if (route.path == "/") {
      let routeTo = "";
      if (store.state.auth.user["roles"][0] == constants.ROLES.SECURITY) {
        routeTo = "search-contractor";
      } else {
        routeTo = "contractorsCompany";
      }
      return {
        valid: false,
        routeTo: routeTo
      };
    }
    return {
      valid: true
    };
  }

  const isValid = route.meta.requiresAuth.some(role => {
    return store.state.auth.user.roles.indexOf(role) != -1;
  });

  return {
    valid: isValid,
    message: !isValid ? store.state.locale.resx.messages.accessDenied : null,
    routeTo: !window.vueApp ? "login" : null
  };
};

export default router;
